module.exports = __webpack_public_path__ + "static/img/8.ccffe70.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/sp/8.png
// module id = v+ij
// module chunks = 0